import { RootState } from "../../store/types";
import { connect } from "react-redux";
import TopMetricsRow from "./index";

const mapStateToProps = (state: RootState) => ({
    primaryGradingVolumeData: state.reviewAndPublish.shiftPlanOutput?.primaryGradingVolume,
    totalOverrides: state.reviewAndPublish.shiftPlanOutput?.overrides,
    shiftTotals: state.reviewAndPublish.shiftPlanOutput?.shiftTotals
});

export default connect(mapStateToProps)(TopMetricsRow);